export default __webpack_public_path__ + "static/media/bg7.6249276d.jpg";